module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-laundry-container"
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveProduct($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "mb-3": ""
    }
  }, [_c('p', {
    staticClass: "text-xs-left bold",
    attrs: {
      "for": "laundry-file mb-0"
    }
  }, [_vm._v("Categoría")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "label": "Categorías",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.categories,
      "readonly": "",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.categoryId),
      callback: function($$v) {
        _vm.model.categoryId = $$v
      },
      expression: "model.categoryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('p', {
    staticClass: "text-xs-left bold",
    attrs: {
      "for": "laundry-file mb-0"
    }
  }, [_vm._v("Imagen para la prenda")]), _vm._v(" "), _c('file-upload-container', {
    attrs: {
      "image-url": _vm.model.urlImage,
      "label-for": 'laundry-file'
    },
    on: {
      "upload": _vm.onUpload
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('p', {
    staticClass: "text-xs-left bold mb-1"
  }, [_vm._v("Nombre de la prenda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "input-form",
    attrs: {
      "type": "text",
      "placeholder": "Nombre de la prenda"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('p', {
    staticClass: "text-xs-left bold mb-1"
  }, [_vm._v("Precio")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.price),
      expression: "model.price",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-form",
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "step": "any"
    },
    domProps: {
      "value": (_vm.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.price = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "actions text-xs-left"
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4f52be2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/laundry/Create.vue
// module id = 1703
// module chunks = 11